import { ROLES } from "utils/helpers/enums/roles.enum"
import { PROFILE_TYPES } from "utils/helpers/enums/shared.enum"

export class UpgradeProfileDTO{
    role: ROLES
    profileType: PROFILE_TYPES
    host: HostUpgradeDTO

    constructor(data: Partial<UpgradeProfileDTO> = {}){
        Object.assign(this,data);
    }
  }

  export class HostUpgradeDTO{
    businessName: string = ''
    businessEmail: string = ''
    industry: string = ''
    businessAddress: string = ''
    businessPhoneNumber: string = ''
    placeId: string = ''

    constructor(data = {}){
      Object.assign(this,data);
    }
  }